exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag-name[data-v-7149ede7]{font-size:32px;font-weight:lighter;margin-right:12px}.badge[data-v-7149ede7]{background:#9c27b0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7149ede7","scoped":true,"sourceMap":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modules/ModuleRelease.vue
// module id = 527
// module chunks = 0